import type { Environment } from '@access-evo/mfe-react-host';

const PRODUCTION_REGISTRIES = [
  'https://oc-registry.eu.guestline.app/registry/oc-client/client.js',
  'https://mfe.pay.accessacloud.com/registry/oc-client/client.js',
];

const NON_PRODUCTION_REGISTRIES = [
  'https://oc-registry.ci.guestline.app/registry/oc-client/client.js',
  'https://mfe-test.pay.accessacloud.com/registry/oc-client/client.js',
];

let loaded = false;

export function loadPayRegistries(environment: Environment | undefined): void {
  if (loaded) {
    return;
  }
  loaded = true;

  const registries = environment === 'prod' ? PRODUCTION_REGISTRIES : NON_PRODUCTION_REGISTRIES;

  for (const src of registries) {
    const script = document.createElement('script');
    script.src = src;
    document.head.appendChild(script);
  }
}
